/**
 * AugmentationToggle Component
 * Toggle button for augmentation options with status indicator
 */

import { cn } from "@/lib/utils";

interface AugmentationToggleProps {
  label: string;
  enabled: boolean;
  onToggle: () => void;
}

export function AugmentationToggle({
  label,
  enabled,
  onToggle,
}: AugmentationToggleProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={cn(
        "relative flex items-center gap-2 px-3 py-2 rounded-lg border transition-all",
        enabled
          ? "border-green-500/40 bg-green-500/10 text-green-500"
          : "border-white/10 bg-white/5 text-muted-foreground hover:border-white/20",
      )}
    >
      {/* Status dot */}
      <div
        className={cn(
          "w-2 h-2 rounded-full",
          enabled ? "bg-green-500" : "bg-white/20",
        )}
      />
      <span className="text-xs font-medium">{label}</span>
    </button>
  );
}
